<template>
  <div class="devices">
    <div class="container-fluid px-0">
      <div class="row no-gutters">
        <div class="col-sm-3 col-md-4 col-lg-4 col-xl-2 d-none d-sm-block sidebar bg-dark-nvx">
          <DevicesListSideBar ref="devicesList"></DevicesListSideBar>
        </div>
        <div role="main" class="col-sm-9 col-md-8 col-lg-8 col-xl-10 mx-0 ml-sm-auto bg-black">
          <DeviceLinksBar></DeviceLinksBar>
          <TrackerPanelInfo></TrackerPanelInfo>
          <TrackerPanelEdit></TrackerPanelEdit>
          <TrackerPanelShare></TrackerPanelShare>
          <TrackerPanelActivity></TrackerPanelActivity>
          <TrackerPanelTemperature></TrackerPanelTemperature>
          <div id="main_map_container" v-show="show_map">
            <div
              class="panel-edit-history"
              v-bind:class="{ isTranslate: !historyisHidden&&!historyisDisable }"
              v-show="title_range&&!historyisDisable"
            >
              <div class="container-scroll">
                <svg
                  class="icon-back-arrow"
                  v-on:click="historyisHidden = !historyisHidden"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 492 492"
                  style="enable-background:new 0 0 492 492;"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <path
                        d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12
			C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084
			c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864
			l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"
                      />
                    </g>
                  </g>
                </svg>
                <div class="scroll">
                  <ul class="container-history">
                    <li :key="item.id" v-for="(item, index) in history_positions">
                      <div
                        class="first-date-day"
                        v-if="_diff(date_start,date_end)>1&&item_new_day(item)"
                      >
                        <p class="date-day">{{item.date_end|formatDay}}</p>
                      </div>
                      <div v-if="item.count > 1">
                        <div
                          v-bind:style="{ ['height']: heightplace(item.date_start, item.date_end) + 'px' }"
                          class="history-block"
                        >
                          <div
                            v-on:click="changeCenter(item)"
                            class="adress"
                            v-if="item.address"
                          >{{item.address}}</div>
                        </div>

                        <div>
                          <div class="history-date">
                            <p class="hour">{{ item.date_start|formatHour }}</p>
                            <div
                              v-if="_diff(date_start,date_end)>1&&changeDay(item.date_start, item.date_end)"
                            >
                              <p class="date-day">{{item.date_end|formatDay}}</p>
                            </div>
                            <p class="hour">{{ item.date_end|formatHour }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex" v-else>
                        <div v-if="index == 0">
                          <div class="history-block-start-end">
                            <div class="adress">{{item.address}}</div>
                            <div class="history-date">
                              <p class="hour">{{ item.date_end|formatHour }}</p>
                            </div>
                          </div>
                        </div>
                        <div v-else-if="index == history_positions.length -1">
                          <div class="history-block-start-end">
                            <div class="adress">{{item.address}}</div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="history-block-sm"></div>
                        </div>
                        <div class="history-date"></div>
                      </div>
                    </li>
                    <div class="bar-timeline"></div>
                  </ul>
                </div>
              </div>
            </div>

            <div v-bind:class="{ resizeMap: !historyisHidden&&!historyisDisable }" id="map"></div>
            <div id="over_map" v-show="show_no_data_msg">
              <h2 class="text-center">{{$t('no_data_period')}}</h2>
            </div>
            <div class="position-fixed top-0 end-0 h-100 shadow p-3 overflow-auto d-flex flex-column"
                 id="sidebar-event"
                 v-if="show_tracker_events" >
              <TrackerEvents :device="selected" :date_start="date_start" :date_end="date_end"></TrackerEvents>
            </div>
          </div>

          <div class="d-flex justify-content-between flex-wrap flex-md-nowrap" v-if="show_map">
            <div style="width:100%" class="btn-toolbar mb-2 mb-md-0 btn-bar-nvx">
              <div
                style="width:100%"
                class="d-flex align-items-center btn-group mb-2 mb-md-0"
                v-show="selected"
              >
                <div
                  class="col-2 btn btn-sm btn-block-nvx history-btn"
                  v-on:click="history(selected), historyisHidden = !historyisHidden"
                  v-show="!title_range&&selected"
                >{{$t('History')}}</div>
                <div
                  class="col-2 btn btn-sm btn-block-nvx history-btn"
                  v-on:click="loadLastMap(), historyisHidden = true, show_tracker_events=false"
                  v-show="title_range"
                >{{$t('Last_Position')}}</div>
                <div class="d-flex col-4 align-items-center">
                  <a class="btn align-center" v-on:click="prev_period()" v-show="title_range">
                    <img src="/images/left-arrow.png" width="32" height="32" />
                  </a>
                  <div class="form-group align-middle dropup my-2" v-show="title_range">
                    <div
                      ref="daterange"
                      id="daterange"
                      class="btn-range btn btn-outline-light align-middle dropdown-toggle"
                    >
                      <span data-feather="calendar"></span>
                      <span>{{title_range}}</span>
                    </div>
                  </div>
                  <a class="btn align-center" v-on:click="next_period()" v-show="title_range">
                    <img src="/images/right-arrow.png" width="32" height="32" />
                  </a>
                </div>
                <div
                    class="col-2 btn btn-sm btn-block-nvx history-btn"
                    v-on:click="show_tracker_events=!show_tracker_events"
                    v-show="title_range"
                >
                  <div v-if="show_tracker_events">{{$t('hide_tracker_events')}}</div>
                  <div v-else>{{$t('show_tracker_events')}}</div>
                    </div>
                <div v-if="title_range&&history_positions.length>1"
                     class="col-4 d-flex justify-content-between gap-4">
                  <div class="py-2 col-8">
                    <input
                        class="align-middle slider-history d-md-none d-lg-block my-3"
                        type="range"
                        min="1"
                        max="100"
                        v-model="history_range_end"
                        @input="on_change_history_range"
                    />
                  </div>
                  <div class="py-2 col-2">
                    <button
                        class="btn btn-primary"
                        v-on:click="play_history()"
                        v-show="!refreshIntervalId"
                    >
                      <span data-feather="play"></span>
                    </button>
                    <button
                        class="btn btn-primary"
                        v-on:click="pause_history()"
                        v-show="refreshIntervalId"
                    >
                      <span data-feather="pause"></span>
                    </button>
                  </div>

                  <div class="col-2">
                    <div class="text-white my-3">{{ history_range_date }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#sidebar-event {
  width: 300px;
  right: 0;
  bottom: 0;
  z-index: 1050;
  border-radius: 20px;
  background-color: #e0e0e0;
}

</style>
<script>
import DevicesListSideBar from "./DevicesListSideBar";
import DeviceLinksBar from "./DeviceLinksBar";
import TrackerPanelInfo from "./TrackerPanelInfo";
import TrackerPanelEdit from "./TrackerPanelEdit";
import TrackerPanelShare from "./TrackerPanelShare";
import TrackerPanelActivity from "./TrackerPanelActivity";
import TrackerPanelTemperature from "./TrackerPanelTemperature"
import TrackerEvents from "./TrackerEvents";

import { HTTP } from "../http-constants";
import * as nvxlib from "../nvxcommon";
import { bus } from "../event-bus";
import gmapsInit from "../gmaps.js";
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

import $ from "jquery";
import "../assets/ith_style.css";
import "../assets/scss/style.scss";

import * as moment from "moment";

const feather = require('feather-icons')

var map = null;
var oms = null;
var last_markers = [];
var history_array = [];
var routePath = null;
var infoWindow = null;
var lastMarkerCluster = null;
var placesMarkerCluster = null;

var trafficLayer;


function TrafficControl(controlDiv, map) {
  // Set CSS for the control border.
  var controlUI = document.createElement("div");
  controlUI.style.backgroundColor = "#fff";
  controlUI.style.border = "2px solid #fff";
  controlUI.style.borderRadius = "3px";
  controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.5)";
  controlUI.style.cursor = "pointer";
  controlUI.style.marginBottom = "5px";
  controlUI.style.textAlign = "center";
  controlUI.title = "Click to recenter the map";
  controlDiv.appendChild(controlUI);

  // Set CSS for the control interior.
  var controlText = document.createElement("div");
  controlText.style.color = "rgb(25,25,25)";
  controlText.style.fontFamily = "Roboto,Arial,sans-serif";
  controlText.style.fontSize = "16px";
  controlText.style.lineHeight = "30px";
  controlText.style.paddingLeft = "5px";
  controlText.style.paddingRight = "5px";
  controlText.innerHTML = app.$t("traffic_enable");
  controlUI.appendChild(controlText);

  // Setup the click event listeners: simply set the map to Chicago.
  controlUI.addEventListener("click", function() {
    if (trafficLayer.getMap()) {
      trafficLayer.setMap(null);
      self.backgroundColor = "rgba(0,0,0,.3)";
    } else {
      trafficLayer.setMap(map);
      self.backgroundColor = "light blue";
    }
  });
}

function initMap() {
  trafficLayer = new google.maps.TrafficLayer();
  if (map == null) {
    map = new google.maps.Map(document.getElementById("map"), {
      zoom: 7,
      scaleControl: true,
      streetViewControl: true
    });
    map.setCenter(new google.maps.LatLng(48.83, 2.28));
    var trafficControlDiv = document.createElement("div");
    var trafficControl = new TrafficControl(trafficControlDiv, map);

    trafficControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(trafficControlDiv);

    var spider_config = {
      keepSpiderfied: true,
      markersWontMove: true,
      markersWontHide: true,
      basicFormatEvents: true
    };
    oms = new OverlappingMarkerSpiderfier(map, spider_config);
  }
}

function resizeMap(positions) {
  if (positions.length == 0) {
    return;
  }
  var bounds = new google.maps.LatLngBounds();

  for (var i = 0; i < positions.length; i++) {
    var position = positions[i];
    bounds.extend({ lat: position.lat, lng: position.lng });
  }
  google.maps.event.addListenerOnce(map, "bounds_changed", function() {
    const _zoom = this.getZoom();
    var new_zoom = Math.min(15, _zoom);
    if (_zoom == 0) {
      new_zoom = 7;
    }
    this.setZoom(new_zoom);
  });
  map.fitBounds(bounds);
}

function device_info(position) {
  let info = "<b>" + position.name.toUpperCase() + "</b> <br><br>";
  
  if (position.date) {
    info += "<img style='margin: auto; width: 15px; padding-right: 2px;' src='/images/loc.png' alt=''> " + app.$t('last_location') + ": " + nvxlib.pretty_date(position.date) + "<br>";
  }
  const filters = app.$options.filters;
  let location_age = moment().diff(moment(position.date), 'hours');
  if (position.arrival_date && location_age < 6) {
    let delta = moment(position.date).diff(moment(position.arrival_date), 'minutes');
    if (delta > 2) {
      let duration_in_place = moment().diff(moment(position.arrival_date), 'minutes');
      if (duration_in_place > 20) {
        info += "<img style='margin: auto; width: 14px; padding-right: 2px;' src='/images/arrive.png' alt=''> " + app.$t("arrived") + ": " + nvxlib.pretty_date(position.arrival_date) + "<br>";
      }
    }
  }
  if (position.stationary>0 && location_age < 24*60 ) {
    info += "<img style='margin: auto; width: 15px; padding-right: 2px;' src='/images/mouv.png' alt=''> " + app.$t('last_movement') + ": " + filters.formatStationary(position.stationary) + "<br>";
  }
  info += "<img style='margin: auto; width: 15px; padding-right: 2px;' src='/images/batterie.png' alt=''> " + app.$t('battery') + ": " + position.battery + "%" + "<br> <br>";
// info += "<img style='margin: auto; width: 15px; padding-right: 2px;' src='/images/flag.png' alt=''> Flag: " + + "<br>";
  let selected = app.$store.state.trackers.selected;
  if (!selected || selected.id != position.id) {
    info +=
        "<button class='btn btn-sm btn-outline-primary' onclick='select_tracker(" +
        position.id +
        ")'>" +
        app.$t("select") +
        "</button>";
  }
  return info;
}


function clearPlaces() {
  if (placesMarkerCluster) {
    placesMarkerCluster.clearMarkers();
  }
}

function setLastMarkers(map, positions) {
  var marker;
  var bounds = new google.maps.LatLngBounds();

  for (var i = 0; i < positions.length; i++) {
    var position = positions[i];
    bounds.extend({ lat: position.lat, lng: position.lng });
    marker = new google.maps.Marker({
      position: { lat: position.lat, lng: position.lng },
      map: map,
      title: position.name,
      nvx_position: position
    });

    last_markers.push(marker);

    oms.addListener("click", function(marker, event) {
      if (infoWindow) {
        infoWindow.close();
      }
      infoWindow = new google.maps.InfoWindow();
      infoWindow.setContent(device_info(marker.nvx_position));
      infoWindow.open(map, marker);
    });

    oms.addMarker(marker);
  }

  oms.addListener("spiderfy", function(markers) {
    if (infoWindow) {
      infoWindow.close();
    }
  });

  // Automatically center the map fitting all markers on the screen
  google.maps.event.addListenerOnce(map, "bounds_changed", function() {
    this.setZoom(Math.min(15, this.getZoom()));
  });
  map.fitBounds(bounds);

  const mcOptions = {
    gridSize: 70,
    maxZoom: 14,
    map: map,
    markers: last_markers
  };
  lastMarkerCluster = new MarkerClusterer(mcOptions);

  google.maps.event.addListener(lastMarkerCluster, "clusterclick", function(
    cluster
  ) {
    map.fitBounds(cluster.getBounds());
    if (map.getZoom() > 16) {
      map.setZoom(16);
    }
  });
}

function place_icon(place_type) {
  if (place_type == "warehouse") {
    return "warehouse.png";
  }
  if (place_type == "store") {
    return "store.png";
  }
  if (place_type == "home") {
    return "home.png";
  }
  if (place_type == "work") {
    return "work.png";
  }
  if (place_type == "school") {
    return "school.png";
  }
  return "place.png";
}

export default {
  name: "mapApp",
  components: {
    DevicesListSideBar,
    DeviceLinksBar,
    TrackerPanelInfo,
    TrackerPanelShare,
    TrackerPanelEdit,
    TrackerPanelActivity,
    TrackerPanelTemperature,
    TrackerEvents
  },
  data() {
    return {
      last_positions: [],
      selected: null,
      history_positions: [],
      history_range_end: 100,
      history_positions_filtered: [],
      places: [],
      date_start: "",
      date_end: "",
      title_range: null,
      show_map: true,
      show_no_data_msg: false,
      refreshIntervalId: null,
      historyisHidden: true,
      historyisDisable: true,
      show_tracker_events: false,
      // trackers: null,
    };
  },
  methods: {

    'setMarkerWithDevice': function (device) {
       for(let i = 0; i< last_markers.length; i++) {
          if (last_markers[i].nvx_position.id == device.id) {
            let updateTitle = device.name
            let icon = {
              url: nvxlib.icon_path(device.tracker_config.icon),
              scaledSize: new google.maps.Size(30, 30)
            }
            last_markers[i].nvx_position.name = updateTitle;
            last_markers[i].setTitle(updateTitle);
            last_markers[i].setIcon(icon);
          }
        }
    },
    
    changeCenter: function(item) {
      map.setCenter({ lat: item.lat, lng: item.lng });
    },
    changeDay: function(d_start, d_end) {
      let date_start = moment(d_start).format("YYYY MM DD");
      let date_end = moment(d_end).format("YYYY MM DD");
      if (date_start != date_end) {
        return true;
      } else {
        return false;
      }
    },
    item_new_day(item) {
      let idx = this.history_positions.indexOf(item);
      if (idx == 0) {
        return true;
      }
      let prev_item = this.history_positions[idx - 1];
      return this.changeDay(item.date_start, prev_item.date_end);
    },
    _diff: function(d_start, d_end) {
      let date1 = moment(d_start);
      let date2 = moment(d_end);
      let _diff = date2.diff(date1, "Day");
      //console.log(_diff);
      return _diff;
    },
    heightplace: function(d_start, d_end) {
      let date1 = moment(d_start);
      let date2 = moment(d_end);
      let _diff = date2.diff(date1, "minutes");
      let height = window.innerHeight;
      let totalMinutes = 1440;
      let heightplace = (_diff * height) / totalMinutes;
      //console.log(heightplace);
      return heightplace;
    },
    loadLastMap: function() {
      var self = this;
      self.show_no_data_msg = false;
      self.title_range = null;
      HTTP.get("/devices/trackers/last/")
        .then(function(re) {
          self.last_positions = re.data;
          self.showLastPositions(self.last_positions);
          let _trackers = self.$store.state.trackers.devices;
          for(let i = 0; i< _trackers.length; i++) {
            self.setMarkerWithDevice(_trackers[i]);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    select: function(tracker) {
      this.selected = tracker;
      if (this.title_range) {
        if (this.selected) {
          this.loadHistoryMap();
        } else {
          this.title_range = null;
          this.history_positions = [];
          this.show_tracker_events = false;
          this.loadLastMap();
        }
      } else if (tracker != null) {
        this.centerMap(tracker);
      } else if (this.last_positions.length > 0) {
        if (infoWindow) {
          infoWindow.close();
        }
        resizeMap(this.last_positions);
      }

    },
    history: function(tracker) {
      var self = this;
      this.selected = tracker;

      this.date_start = moment().startOf("day");
      this.date_end = moment()
        .startOf("day")
        .add(1, "days");
      this.title_range = this.date_range_title();

      var startDay = this.date_start;

      var _daterange = this.$refs.daterange;
      $(_daterange).daterangepicker(
        {
          locale: {
            format: "dddd Do MMMM",
            separator: " - ",
            applyLabel: app.$t("apply"),
            cancelLabel: app.$t("cancel"),
          },
          startDate: startDay,
          todayHighlight: true,
          drops: "up",
          opens: "center"
        },
        function(start, end) {
          console.log(
            "A new date selection was made: " +
              start.format("YYYY-MM-DD") +
              " to " +
              end.format("YYYY-MM-DD")
          );
          self.date_start = start;
          self.date_end = end;
          self.title_range = self.date_range_title();
          self.loadHistoryMap();
        }
      );
      this.loadHistoryMap();
      this.loadPlaces(this.selected);
    },
    loadPlaces: function(tracker) {
      if (tracker == null) {
        return;
      }
      var path = "/devices/" + tracker.id + "/tracker_places/";
      var self = this;
      HTTP.get(path)
        .then(function(re) {
          self.places = re.data;
          self.showPlaces(self.places);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showPlaces: function (places) {
      initMap();
      var marker_places = [];
      for (var i = 0; i < places.length; i++) {
        var place = places[i];
        var icon = {
          url: "/js/gmaps/" + place_icon(place.type),
          scaledSize: new google.maps.Size(20, 20),
          labelOrigin: new google.maps.Point(10, 26)
        };
        var label = {
          text: place.name,
          fontSize: "12px",
          color: "black"
        };

        var marker = new google.maps.Marker({
          position: {lat: place.lat, lng: place.lng},
          map: map,
          title: place.name,
          label: label,
          icon: icon,
          zindex: 1
        });
        marker_places.push(marker);
      }

      var mcOptions = {
        gridSize: 70,
        maxZoom: 13,
        imagePath: "/js/markerclusterer/m"
      };
      placesMarkerCluster = new MarkerClusterer(map, marker_places, mcOptions);
    },
    resolve_addresses() {
        let self= this;
      for (let j = 0; j < self.history_positions.length; j++) {
        let item = self.history_positions[j];
        if (
          self.history_positions[j].count > 1 ||
          j == 0 ||
          j == self.history_positions.length - 1
        ) {
          nvxlib.resolve_address(item.lat, item.lng, function(new_address) {
            self.history_positions[j].address = new_address;
          });
        }
      }
    },
    history_marker_info: function (position, full_date) {
      const format = full_date ? "LLL" : "HH:mm";
      const start = moment(position.date_start).format(format);

      if (position.count > 1) {
        const end = moment(position.date_end).format(format);
        let _str = `${start}-${end}<br>${position.count} ${this.$i18n.t('positions')}`;
        if (position.accuracy > 0) {
          _str += `<br>${position.accuracy}m ${this.$i18n.t('accuracy')}`;
        }
        return _str
      }

      return `${start}<br>@${position.accuracy}m ${this.$i18n.t('accuracy')}`;
    },
    convertFromTimeline: function (timeline_data) {
      //console.log("timeline_data", timeline_data);
      let data = [];
      for (let i = timeline_data.length-1; i >=0; i--) {
        let item = timeline_data[i];
        if (item.type === "stationary") {
          let accuracy = -1;
          if (item.location_list && item.location_list.length > 0) {
            accuracy = Math.round(item.location_list.reduce((sum, item) => sum + item.accuracy, 0) / item.location_list.length);
          }
          let position = {
            id: item.id,
            lat: item.lat,
            lng: item.lng,
            accuracy: accuracy,
            date_start: item.datetime_start,
            date_end: item.datetime_end,
            count: item.date_list.length
          };
          data.push(position);
        } else {
          for (let j = 0; j < item.location_list.length;  j++) {
            let position = {
              id: item.id,
              lat: item.location_list[j].lat,
              lng: item.location_list[j].lng,
              accuracy: item.location_list[j].accuracy,
              date_start: item.date_list[j],
              date_end: item.date_list[j],
              count: 1
            };
            data.push(position);
          }
        }

      }
      return data;
    },
    loadHistoryMap: function() {
      let deviceId = this.selected.id;
      let timestamp1 = this.date_start.unix();
      let timestamp2 = this.date_end.unix();
      let limit = 200;

      let path = `/api/v2/devices/${deviceId}/timeline/?timestamp1=${timestamp1}&timestamp2=${timestamp2}&limit=${limit}`;

      var self = this;
      HTTP.get(path)
        .then(function(re) {
          self.history_positions = self.convertFromTimeline(re.data);
          if (self.history_positions.length) {
            self.show_no_data_msg = false;
          } else {
            self.show_no_data_msg = true;
          }
          self.loadHistory(self.history_positions, true);
          if (!self.historyisDisable) {
            self.resolve_addresses();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    date_range_title: function() {
      if (this.date_start == "") {
        return "...";
      }

      var _diff = this.date_end.diff(this.date_start, "hours");
      var _title = this.date_start.format("dddd Do MMMM");
      if (_diff > 24) {
        _title += " - " + this.date_end.format("dddd Do MMMM");
      }
      return _title;
    },
    next_period: function() {
      let _diff = Math.max(1, this.date_end.diff(this.date_start, "days"));
      this.date_start = this.date_start.clone().add(_diff, "days");
      this.date_end = this.date_end.clone().add(_diff, "days");
      console.log("****start %s end %s", this.date_start, this.date_end);
      this.title_range = this.date_range_title();
      this.history_range_end = 100;
      this.loadHistoryMap();
    },
    prev_period: function() {
      let _diff = Math.max(1, this.date_end.diff(this.date_start, "days"));
      this.date_start = this.date_start.clone().subtract(_diff, "days");
      this.date_end = this.date_end.clone().subtract(_diff, "days");
      this.title_range = this.date_range_title();
      this.history_range_end = 100;
      this.loadHistoryMap();
    },
    resizeOnTrackers: function(trackers) {
      var ids = trackers.map(a => a.id);
      if (ids.length && this.last_positions) {
        var _positions = this.last_positions.filter(elem =>
          ids.includes(elem.id)
        );
        resizeMap(_positions);
      }
    },
    on_change_history_range: function() {
      console.log("range %d", this.history_range_end);
      var range_end =
        ((this.date_end - this.date_start) * this.history_range_end) / 100 +
        this.date_start;
      console.log(range_end);
      var history_positions = this.history_positions;
      var positions = history_positions.filter(
        position => Date.parse(position.date_start) < range_end
      );
      if (
        JSON.stringify(positions) !=
        JSON.stringify(this.history_positions_filtered)
      ) {
        this.history_positions_filtered = positions;
        this.loadHistory(positions, false);
      }
    },
    play_history: function() {
      this.history_range_end = 0;
      var self = this;
      self.refreshIntervalId = setInterval(frame, 100);

      function frame() {
        if (self.history_range_end >= 100) {
          clearInterval(self.refreshIntervalId);
          self.refreshIntervalId = null;
          return;
        }

        self.history_range_end += 1;
        self.on_change_history_range();
      }
    },
    pause_history: function() {
      var self = this;
      if (self.refreshIntervalId) {
        clearInterval(self.refreshIntervalId);
        self.refreshIntervalId = null;
      }
    },
    showLastPositions: function(positions) {
      initMap();
      clearPlaces();
      this.clearHistory();
      this.clearLast();
      if (positions.length) {
        setLastMarkers(map, positions);
      }
    },
    clearLast: function () {
      if (infoWindow) {
        infoWindow.close();
      }
      if (lastMarkerCluster) {
        lastMarkerCluster.clearMarkers();
      }
      for (let i = 0; i < last_markers.length; i++) {
        last_markers[i].setMap(null);
      }
      last_markers = [];
    },
    clearHistory: function() {
      if (routePath != null) {
        routePath.setMap(null);
        routePath = null;
      }
      if (infoWindow) {
        infoWindow.close();
      }
      for (var i = 0; i < history_array.length; i++) {
        history_array[i].setMap(null);
      }
      history_array = [];
    },
    loadHistory: function(positions, resize) {
      initMap();

      this.clearLast();
      this.clearHistory();
      this.setHistoryMarkers(map, positions, resize);
    },
    history_marker_title: function(position, full_date) {
      let date1 = moment(position["date_start"]);

      let _format = "HH:mm";
      if (full_date) {
        _format = "LLL";
      }
      var _info = date1.format(_format);
      if (position.count > 1) {
        let date2 = moment(position["date_end"]);
        _info += "-" + date2.format(_format);
      }
      return _info;
    },
    setHistoryMarkers: function(map, positions, resize) {
      var self = this;
      var bounds = new google.maps.LatLngBounds();
      var coordinates = [];

      var full_date = false;
      var _diff = self.date_end.diff(self.date_start, "hours");
      if (_diff > 24) {
        full_date = true;
      }

      for (let i = 0; i < positions.length; i++) {
        var position = positions[i];

        let point = { lat: position.lat, lng: position.lng };
        bounds.extend(point);
        coordinates.push(point);

        let marker = new google.maps.Marker({
          position: { lat: position.lat, lng: position.lng },
          map: map,
          title: self.history_marker_title(position, full_date),
          zIndex: 999
        });

        let scale = 1;
        const date_start = Date.parse(position.date_start);
        const date_end = Date.parse(position.date_end);

        let _diff = (date_end - date_start) / 1000 / 60;
        if (position.count > 1 && _diff > 2) {
          scale = 1.5;
        }
        if (i == positions.length - 1) {
          let icon = {
            url: "/js/gmaps/" + "flag.png",
            scaledSize: new google.maps.Size(32 * scale, 32 * scale),
            anchor: new google.maps.Point(16 * scale, 24 * scale)
          };
          marker.setIcon(icon);
        } else {
          var size = scale * 10;
          let icon = {
            url: "/js/gmaps/" + "smallplace.png",
            scaledSize: new google.maps.Size(size * 2, size * 2),
            anchor: new google.maps.Point(size, size)
          };
          marker.setIcon(icon);
        }

        history_array.push(marker);


        // Allow each marker to have an info window
        google.maps.event.addListener(
          marker,
          "click",
          (function(marker, i) {
            return function() {
              var position = positions[i];
              var full_date = false;
              var _diff = self.date_end.diff(self.date_start, "hours");
              if (_diff > 24) {
                full_date = true;
              }
              var _title = self.history_marker_info(position, full_date);
              if (infoWindow) {
                infoWindow.close();
              }
              infoWindow = new google.maps.InfoWindow();
              infoWindow.setContent(_title);
              infoWindow.open(map, marker);
            };
          })(marker, i)
        );
      }

      if (resize && positions.length) {
        google.maps.event.addListenerOnce(map, "bounds_changed", function() {
          this.setZoom(Math.min(15, this.getZoom()));
        });
        map.fitBounds(bounds);
      }
      routePath = new google.maps.Polyline({
        path: coordinates,
        geodesic: true,
        strokeColor: "#FF0000",
        strokeOpacity: 1.0,
        strokeWeight: 2
      });

      routePath.setMap(map);
    },
    centerMap: function(tracker) {
      // console.log(tracker);
      if (infoWindow) {
        infoWindow.close();
      }
      var _positions = this.last_positions;
      var idx = _positions.findIndex(x => x.id == tracker.id);
      if (idx >= 0) {
        var pos = _positions[idx];

        map.setCenter({ lat: pos.lat, lng: pos.lng });
        map.setZoom(Math.max(15, map.getZoom()));

        var marker = last_markers[idx];

        infoWindow = new google.maps.InfoWindow();
        infoWindow.setContent(device_info(pos));
        infoWindow.open(map, marker);
      } else {
        resizeMap(_positions);
      }
    }
  },
  computed: {
    history_range_date: function() {
      let date1 = moment(this.date_end).subtract(1, "minutes");
      if (this.history_range_end != 100) {
        var range_end =
          ((this.date_end - this.date_start) * this.history_range_end) / 100 +
          this.date_start;
        date1 = moment(range_end);
      }
      return date1.format("HH:mm");
    }
  },
  async mounted() {
    const google = await gmapsInit();
    this.loadLastMap();
  },
  updated: function () {
    feather.replace();
  },
  created: function() {
    map = null;
    let self = this;

    bus.$on("update_trackers", device => {
     self.setMarkerWithDevice(device.device)
    });

    bus.$on("resize_trackers", trackers => {
      self.resizeOnTrackers(trackers);
        for(let i = 0; i< trackers.length; i++) {
          self.setMarkerWithDevice(trackers[i])
        }
    });

    bus.$on("tracker_panel", elem => {
      if (elem.action != "map") {
        self.title_range = null;
        self.historyisDisable = true;
      }
      if (elem.action == "map") {
        self.show_map = true;
        self.select(elem.tracker);
      } else {
        self.show_map = false;
      }
    });

    window.select_tracker = function(device_id) {
      infoWindow.close();
      bus.$emit("select_tracker", { id: device_id });
    };
  }
};
</script>